import styled from 'styled-components';

const CheckBoxMargin = styled.div`
  margin-top: 80px;
`;

export default CheckBoxMargin;
